import { render, staticRenderFns } from "./EditPushNotificationTemplate.vue?vue&type=template&id=ad2f68d6&"
import script from "./EditPushNotificationTemplate.vue?vue&type=script&lang=js&"
export * from "./EditPushNotificationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EditPushNotificationTemplate.vue?vue&type=style&index=0&id=ad2f68d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports